import {
  ListItem,
  ListItemText
} from '@mui/material'
import React from 'react'

interface ListItemNoIconProps {
  primary: string,
  secondary: string
}

export const ListItemNoIcon: React.FC<ListItemNoIconProps> = ({
  primary,
  secondary
}) => {
  return (
    <ListItem>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItem>
  )
}
